var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search page-content" }, [
    _vm.isSearchEnabled
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "search-bar-holder" },
              [
                _vm.showBackBtn && !this.mobileBigAndBelow
                  ? _c(
                      "span",
                      {
                        staticClass: "back-button",
                        on: {
                          click: function($event) {
                            return _vm.goBack()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "icon-back" }),
                        _vm._v("  Back\n      ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-flex",
                  {
                    staticClass: "search-bar",
                    attrs: { sm12: "", "align-content-end": "" }
                  },
                  [_c("search-bar")],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.routeName === "search"
              ? _c("search-results")
              : _vm.routeName === "searchsport" ||
                _vm.routeName === "searchcompetition"
              ? _c("sport-and-competition-events-list")
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50dc56b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50dc56b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SearchPage.vue
// module id = null
// module chunks = 